import { defaultTheme } from 'gd-design-library';

export const colors = {
  ...defaultTheme.colors,
  primary: {
    default: '#111111',
    'default.80': '#222222',
    'default.10': '#F5F5F5'
  },
  neutral: {
    white: '#FFFFFF',
    black: '#111111',
    'grey.100': '#4A4A4A',
    'grey.90': '#646464',
    'grey.80': '#6A6A6A',
    'grey.60': '#8F8F8F',
    'grey.40': '#B0B0B0',
    'grey.30': '#CCCCCC',
    'grey.20': '#E0E0E0',
    'grey.10': '#EEF2F3'
  },
  alert: {
    red: '#CD0000'
  },
  red: '#EA5B25',
  blue: '#0071BC',
  green: '#00795B',
  orange: '#F7994D',
  heroCarouselLight: '#EDEAE5',
  paymentMethodAccordion: '#F6F7F8',
  buttonHover: '#585858',
  priceColor: '#ECEEF2',
  discountBackground: '#E7E7E7',
  border: {
    ...defaultTheme.colors.border,
    default: 'rgba(0, 0, 0, 0.12)'
  }
};
